// extracted by mini-css-extract-plugin
export default {"navbar":"NavbarSimple_navbar__OJlIl","footer":"NavbarSimple_footer__Gssmt","link":"NavbarSimple_link__7qCNu","linkIcon":"NavbarSimple_linkIcon__YmTyB"};